import Api from "../Api";

class ApiIndicesComparison extends Api {
  static getIndicesComparisonData(
    indicesToCompare: string[],
    startingDate: { year: number; month: number },
    endingDate: { year: number; month: number }
  ) {
    return ApiIndicesComparison.instance.axiosInst.post(
      "/bond/index-performance-comparison",
      {
        indicesToCompare,
        startingDate,
        endingDate,
      }
    );
  }
}

export default ApiIndicesComparison;